import React from "react";

const BookingSuccessIcon = () => {
  return (
    <svg
      width="373"
      height="372"
      viewBox="0 0 373 372"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.5">
        <circle
          cx="186.979"
          cy="50.4708"
          r="13.6097"
          fill="url(#paint0_linear_1981_2980)"
        />
        <circle
          cx="142.771"
          cy="21.009"
          r="17.1526"
          transform="rotate(-15 142.771 21.009)"
          fill="url(#paint1_linear_1981_2980)"
        />
        <circle
          cx="90.6443"
          cy="89.6666"
          r="13.6807"
          transform="rotate(-45 90.6443 89.6666)"
          fill="url(#paint2_linear_1981_2980)"
        />
        <circle
          cx="38.2797"
          cy="100.149"
          r="17.2421"
          transform="rotate(-60 38.2797 100.149)"
          fill="url(#paint3_linear_1981_2980)"
        />
        <circle
          cx="322.508"
          cy="186.001"
          r="13.6097"
          transform="rotate(90 322.508 186.001)"
          fill="url(#paint4_linear_1981_2980)"
        />
        <circle
          cx="351.971"
          cy="141.791"
          r="17.1526"
          transform="rotate(75 351.971 141.791)"
          fill="url(#paint5_linear_1981_2980)"
        />
        <circle
          cx="283.314"
          cy="89.6666"
          r="13.6807"
          transform="rotate(45 283.314 89.6666)"
          fill="url(#paint6_linear_1981_2980)"
        />
        <circle
          cx="272.833"
          cy="37.301"
          r="17.2421"
          transform="rotate(30 272.833 37.301)"
          fill="url(#paint7_linear_1981_2980)"
        />
        <circle
          cx="186.979"
          cy="321.53"
          r="13.6097"
          fill="url(#paint8_linear_1981_2980)"
        />
        <circle
          cx="231.189"
          cy="350.992"
          r="17.1526"
          transform="rotate(-15 231.189 350.992)"
          fill="url(#paint9_linear_1981_2980)"
        />
        <circle
          cx="283.312"
          cy="282.334"
          r="13.6807"
          transform="rotate(-45 283.312 282.334)"
          fill="url(#paint10_linear_1981_2980)"
        />
        <circle
          cx="335.678"
          cy="271.852"
          r="17.2421"
          transform="rotate(-60 335.678 271.852)"
          fill="url(#paint11_linear_1981_2980)"
        />
        <circle
          cx="51.4489"
          cy="186.001"
          r="13.6097"
          transform="rotate(90 51.4489 186.001)"
          fill="url(#paint12_linear_1981_2980)"
        />
        <circle
          cx="21.9865"
          cy="230.21"
          r="17.1526"
          transform="rotate(75 21.9865 230.21)"
          fill="url(#paint13_linear_1981_2980)"
        />
        <circle
          cx="90.6426"
          cy="282.334"
          r="13.6807"
          transform="rotate(45 90.6426 282.334)"
          fill="url(#paint14_linear_1981_2980)"
        />
        <circle
          cx="101.126"
          cy="334.7"
          r="17.2421"
          transform="rotate(30 101.126 334.7)"
          fill="url(#paint15_linear_1981_2980)"
        />
        <circle
          cx="134.136"
          cy="94.474"
          r="10.6127"
          transform="rotate(-30 134.136 94.474)"
          fill="url(#paint16_linear_1981_2980)"
        />
        <circle
          cx="84.3626"
          cy="158.504"
          r="10.6681"
          transform="rotate(-75 84.3626 158.504)"
          fill="url(#paint17_linear_1981_2980)"
        />
        <circle
          cx="278.504"
          cy="133.158"
          r="10.6127"
          transform="rotate(60 278.504 133.158)"
          fill="url(#paint18_linear_1981_2980)"
        />
        <circle
          cx="214.475"
          cy="83.3831"
          r="10.6681"
          transform="rotate(15 214.475 83.3831)"
          fill="url(#paint19_linear_1981_2980)"
        />
        <circle
          cx="239.822"
          cy="277.526"
          r="10.6127"
          transform="rotate(-30 239.822 277.526)"
          fill="url(#paint20_linear_1981_2980)"
        />
        <circle
          cx="289.595"
          cy="213.496"
          r="10.6681"
          transform="rotate(-75 289.595 213.496)"
          fill="url(#paint21_linear_1981_2980)"
        />
        <circle
          cx="95.4514"
          cy="238.843"
          r="10.6127"
          transform="rotate(60 95.4514 238.843)"
          fill="url(#paint22_linear_1981_2980)"
        />
        <circle
          cx="159.481"
          cy="288.618"
          r="10.6681"
          transform="rotate(15 159.481 288.618)"
          fill="url(#paint23_linear_1981_2980)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_1981_2980"
          x1="175.912"
          y1="50.4708"
          x2="198.644"
          y2="50.4708"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0EEA8D" />
          <stop offset="1" stopColor="#D8EA10" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1981_2980"
          x1="128.823"
          y1="21.009"
          x2="157.474"
          y2="21.009"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0EEA8D" />
          <stop offset="1" stopColor="#D8EA10" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1981_2980"
          x1="79.5193"
          y1="89.6666"
          x2="102.371"
          y2="89.6666"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0EEA8D" />
          <stop offset="1" stopColor="#D8EA10" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1981_2980"
          x1="24.2587"
          y1="100.149"
          x2="53.0587"
          y2="100.149"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0EEA8D" />
          <stop offset="1" stopColor="#D8EA10" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_1981_2980"
          x1="311.44"
          y1="186.001"
          x2="334.173"
          y2="186.001"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0EEA8D" />
          <stop offset="1" stopColor="#D8EA10" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_1981_2980"
          x1="338.023"
          y1="141.791"
          x2="366.673"
          y2="141.791"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0EEA8D" />
          <stop offset="1" stopColor="#D8EA10" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_1981_2980"
          x1="272.19"
          y1="89.6666"
          x2="295.041"
          y2="89.6666"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0EEA8D" />
          <stop offset="1" stopColor="#D8EA10" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_1981_2980"
          x1="258.812"
          y1="37.301"
          x2="287.612"
          y2="37.301"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0EEA8D" />
          <stop offset="1" stopColor="#D8EA10" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_1981_2980"
          x1="175.912"
          y1="321.53"
          x2="198.644"
          y2="321.53"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0EEA8D" />
          <stop offset="1" stopColor="#D8EA10" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_1981_2980"
          x1="217.241"
          y1="350.992"
          x2="245.892"
          y2="350.992"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0EEA8D" />
          <stop offset="1" stopColor="#D8EA10" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_1981_2980"
          x1="272.187"
          y1="282.335"
          x2="295.039"
          y2="282.335"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0EEA8D" />
          <stop offset="1" stopColor="#D8EA10" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_1981_2980"
          x1="321.657"
          y1="271.852"
          x2="350.457"
          y2="271.852"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0EEA8D" />
          <stop offset="1" stopColor="#D8EA10" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_1981_2980"
          x1="40.3817"
          y1="186.001"
          x2="63.1144"
          y2="186.001"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0EEA8D" />
          <stop offset="1" stopColor="#D8EA10" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_1981_2980"
          x1="8.03818"
          y1="230.21"
          x2="36.6887"
          y2="230.21"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0EEA8D" />
          <stop offset="1" stopColor="#D8EA10" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_1981_2980"
          x1="79.5176"
          y1="282.334"
          x2="102.369"
          y2="282.334"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0EEA8D" />
          <stop offset="1" stopColor="#D8EA10" />
        </linearGradient>
        <linearGradient
          id="paint15_linear_1981_2980"
          x1="87.1044"
          y1="334.7"
          x2="115.904"
          y2="334.7"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0EEA8D" />
          <stop offset="1" stopColor="#D8EA10" />
        </linearGradient>
        <linearGradient
          id="paint16_linear_1981_2980"
          x1="125.506"
          y1="94.474"
          x2="143.233"
          y2="94.474"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0EEA8D" />
          <stop offset="1" stopColor="#D8EA10" />
        </linearGradient>
        <linearGradient
          id="paint17_linear_1981_2980"
          x1="75.6874"
          y1="158.505"
          x2="93.5067"
          y2="158.505"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0EEA8D" />
          <stop offset="1" stopColor="#D8EA10" />
        </linearGradient>
        <linearGradient
          id="paint18_linear_1981_2980"
          x1="269.874"
          y1="133.158"
          x2="287.601"
          y2="133.158"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0EEA8D" />
          <stop offset="1" stopColor="#D8EA10" />
        </linearGradient>
        <linearGradient
          id="paint19_linear_1981_2980"
          x1="205.8"
          y1="83.3831"
          x2="223.619"
          y2="83.3831"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0EEA8D" />
          <stop offset="1" stopColor="#D8EA10" />
        </linearGradient>
        <linearGradient
          id="paint20_linear_1981_2980"
          x1="231.191"
          y1="277.526"
          x2="248.918"
          y2="277.526"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0EEA8D" />
          <stop offset="1" stopColor="#D8EA10" />
        </linearGradient>
        <linearGradient
          id="paint21_linear_1981_2980"
          x1="280.92"
          y1="213.496"
          x2="298.739"
          y2="213.496"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0EEA8D" />
          <stop offset="1" stopColor="#D8EA10" />
        </linearGradient>
        <linearGradient
          id="paint22_linear_1981_2980"
          x1="86.8213"
          y1="238.843"
          x2="104.548"
          y2="238.843"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0EEA8D" />
          <stop offset="1" stopColor="#D8EA10" />
        </linearGradient>
        <linearGradient
          id="paint23_linear_1981_2980"
          x1="150.806"
          y1="288.618"
          x2="168.625"
          y2="288.618"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0EEA8D" />
          <stop offset="1" stopColor="#D8EA10" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default BookingSuccessIcon;
